<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LRvmhH/images/9780825477614_cover.jpg?1684514595215" alt="This image is the cover for the book Millstone of Doubt, Thorndike & Swann Regency Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Millstone of Doubt, Thorndike & Swann Regency Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Regency London's detective duo is back on a new case--and this one is going to be a killer</b><p></p><p>Caught in the explosion of the Hammersmith Mill in London, Bow Street Runner Daniel Swann rushes to help any survivors only to find the mill's owner dead of an apparent gunshot.</p><p></p><p>Even though the owner's daughter, Agatha Montgomery, mourns his death, it seems there are more than a few people with motive for murder. But Daniel can't take this investigation slow and steady. Instead, he must dig through all the suspects as quickly as he can, because the clock is ticking until his mysterious patronage--and his job as a runner--comes to an abrupt and painful end. It seems to Daniel that, like his earthly father, his heavenly Father has abandoned him to the fates.</p><p></p><p>Lady Juliette Thorndike is Agatha's bosom friend and has the inside knowledge of the wealthy London ton to be invaluable to Daniel. She should be in a perfect position to help with the case. Still, her instructor in the art of spy craft orders her to stay out of the investigation. But circumstances intervene, dropping her into the middle of the deadly pursuit.</p><p></p><p>When a dreadful accident ends in another death on the mill floor, Daniel discovers a connection to his murder case--and to his own secret past. Now he and Juliette are in a race to find the killer before his time runs out.</p><p></p><p>"Erica Vetsch once again weaves a classic tale of how the old affects the new. An artfully told story that will have you wondering at the outcome until the final pages are read."-- Ruth Logan Herne, <i>USA TODAY</i> best-selling author</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Erica Vetsch
      </h2>
      
      <p class="authorDescription body article">Erica Vetsch is a <i>New York Times</i> best-selling author and ACFW Carol Award winner, and has been a <i>Romantic Times</i> top pick for her previous books. She loves Jesus, history, romance, and watching sports. This transplanted Kansan now makes her home in Rochester, Minnesota. Learn more about Erica at www.ericavetsch.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Kregel Publications
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?15d9b322